export default __webpack_public_path__ + "static/media/src3_pitchnet.c38130a5.mp3";